























































    import { Letter } from '@/store/models/Letter/Letter';
    import  {CommentInfo}  from '@/store/models/Comment/CommentInfo';
    import { Component, Vue,Prop,Watch } from 'vue-property-decorator';
    import * as $ from 'jquery';
    import store from '@/store';
    import * as letterPossessionCommentService from '@/store/Services/letterPossessionCommentService';
    import * as util from '@/util/utils.ts';
    import SingleLetterPossessionComment from '@/components/Cartable/LetterDetails/LettePossessionComment/SingleLetterPossessionComment/SingleLetterPossessionComment.vue';
    import { component } from 'vue/types/umd';
    import FullPageLoader from '@/components/UiComponents/FullPageLoader.vue';
    import DateBookmark from '@/components/Cartable/EnterpriseForm/BookmarkComponents/DateBookmark.vue';
    import TimeInput from '@/components/Cartable/EnterpriseForm/BookmarkComponents/TimeInput.vue';
    import { DateBaseOnCurrentTimeConverter } from '@/util/dateConverter';
    import * as letterService from '@/store/Services/letterServices';
    import { utc } from 'moment';
    import { getPersianFullFormatDate } from '@/util/utils';
    import { getPersianDate } from '@/util/utils';
    import AutoTextarea from '@/components/UiComponents/AutoTextarea/AutoTextarea.vue'


    @Component({
        components:{SingleLetterPossessionComment,FullPageLoader,TimeInput,DateBookmark,AutoTextarea}
    })
    export default class LettePossessionComment extends Vue {
        
        shallShowAllarm=false;
        loading=false;
        comment= '';
        commentId= '';
        ownerId= '';
        alarm ={} as string;
        @Prop() letter?: Letter;
        @Prop() serverTime?: string;
        Allcomments = [] as CommentInfo [];
        hours= 0;
        mins= 0;
        time= '';
        get controlName(){
             return ''
        // if(this.tableRowIndex != undefined)
        //     return this.englishName + this.tableRowIndex;
        // else return this.englishName;
    }
    mounted(){
        $("#personnelNoteDrowpdown").popup({
            closable: true,
            on:'click',
            delay: {
                show: 50,
                hide: 0
            },
            lastResort:"bottom center"
            // onshow:this.readComment()
        });
        this.ownerId =  store.state.ownerId;
        this.Allcomments=[];
        this.comment='';
        this.readComment()
        
    }

    created(){
        store.state.eventHub.$on('readComments',this.readComment)
        // this.serverTime = await letterService.getServerTime();
        // const dateConverter = new  DateBaseOnCurrentTimeConverter();
        // if(!this.serverTime)return '';
        const now = new Date();
        const utcTimestamp = Date.UTC(now.getUTCFullYear(),now.getUTCMonth(), now.getUTCDate() , 
        now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
        // this.alarm=getPersianDate(utcTimestamp,this.serverTime)
        this.alarm=getPersianDate(utcTimestamp.toString(),"YYYY/MM/DD",false)
    }
        async onEditComment(e: any){
            const ownerId =  store.state.ownerId;
            this.comment=e.comment;
            this.commentId=e.id;
            console.log(e.id);
        }

        async setAlarm(){
            if(this.shallShowAllarm==false){
                this.shallShowAllarm=true;
            }else if(this.shallShowAllarm==true){
                this.shallShowAllarm=false;
            }
            this.alarm = '';
        }


        async saveComment(){
        const ownerId =  store.state.ownerId;
        let alarmTime= {} as any;
        if(this.alarm!= null || this.alarm!= undefined){
            // const currentDate = getPersianDate((new Date()).toString(),"YYYY/MM/DD",false);
            const currentDate = new Date();
            const test=this.alarm.split('/',3);
            const time=this.time.split(':');
            const result=this.jalaliToGregorian(parseInt(test[0]),parseInt(test[1]),parseInt(test[2]))
            const date =  new Date(result[0],result[1],result[2],parseInt(time[0]),parseInt(time[1]));
            // alarmTime=new Date(parseInt(this.alarm)).toUTCString()
            alarmTime=date;
            
        }else{
            alarmTime= undefined;
        }
        if(this.commentId== ''){
            this.commentId= util.getNewGuid()
        }
        if(this.letter){
            try {
                this.loading=true;
                const result=await letterPossessionCommentService.saveComment(this.comment,this.letter.letterPossessionId,this.commentId,new Date(),ownerId,alarmTime);
                this.letter.commentPossessionId=result.id;
                this.comment='';    
            } catch (error) {
                console.log(error)
            }finally{
                this.loading=false;
                this.readComment();
                this.comment='';
                this.commentId='';
                this.alarm= '';
            }
        }

    }

    
 jalaliToGregorian(jy: number, jm: number, jd: number): any {
  let gy, gm, gd, days;
  jy += 1595;
  days = -355668 + (365 * jy) + (~~(jy / 33) * 8) + ~~(((jy % 33) + 3) / 4) + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
  gy = 400 * ~~(days / 146097);
  days %= 146097;
  if (days > 36524) {
    gy += 100 * ~~(--days / 36524);
    days %= 36524;
    if (days >= 365) days++;
  }
  gy += 4 * ~~(days / 1461);
  days %= 1461;
  if (days > 365) {
    gy += ~~((days - 1) / 365);
    days = (days - 1) % 365;
  }
  gd = days + 1;
  const sala = [0, 31, ((gy % 4 === 0 && gy % 100 !== 0) || (gy % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  for (gm = 0; gm < 13 && gd > sala[gm]; gm++) gd -= sala[gm];
  return [gy, gm, gd];
}

    clearComment(){
        this.comment='';
    }

    @Watch("letter")
    async readComment(){
        this.comment='';
        const ownerId =  store.state.ownerId;
            if(this.letter){
                this.loading=true;
                const result=await letterPossessionCommentService.ReadComments(ownerId,this.letter.letterPossessionId);
                this.Allcomments=result.data;
                this.loading=false;
            }
        }
    
}
